import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'
import {
    getAllCommentsUserIds,
    getComments,
    getCommentsCount,
    getCommentsScrollTo,
    getEditingCommentId,
    getEditingCommentText,
    getRecentlyAddedCommentsIds,
    getUpdatingCommentId,
    getUsers,
    isCommentsLoading,
    isEditTaskPanelEditable,
    isNewCommentsOnTop,
    isSendingComment
} from './editPanel/selectors'
import {getLoggedInUser} from '../../loggedInUser/selectors'
import CommentsSection from '../comments/CommentsSection'
import {commentsActions, loadMoreComments, saveComment, deleteComment, startEditComment, saveEditingComment} from './editPanel/actions'

export default connect(
    state => ({
        comments: getComments(state),
        users: getUsers(state),
        commentsCount: getCommentsCount(state),
        allCommentsUserIds: getAllCommentsUserIds(state),
        loggedInUser: getLoggedInUser(state),
        isNewCommentsOnTop: isNewCommentsOnTop(state),
        recentlyAddedCommentsIds: getRecentlyAddedCommentsIds(state),
        commentsScrollTo: getCommentsScrollTo(state),
        editingCommentId: getEditingCommentId(state),
        editingCommentText: getEditingCommentText(state),
        loading: isCommentsLoading(state),
        sendingComment: isSendingComment(state),
        updatingCommentId: getUpdatingCommentId(state),
        canManage: isEditTaskPanelEditable(state),
    }),
    dispatch => ({
        loadMoreComments: bindActionCreators(loadMoreComments, dispatch),
        saveComment: bindActionCreators(saveComment, dispatch),
        deleteComment: bindActionCreators(deleteComment, dispatch),
        changeCommentsOrder: bindActionCreators(commentsActions.changeCommentsOrder, dispatch),
        resetCommentsScrollTo: bindActionCreators(commentsActions.resetCommentsScrollTo, dispatch),
        startEditComment: bindActionCreators(startEditComment, dispatch),
        cancelEditComment: bindActionCreators(commentsActions.cancelEditComment, dispatch),
        updateEditingCommentText: bindActionCreators(commentsActions.updateEditingCommentText, dispatch),
        saveEditingComment: bindActionCreators(saveEditingComment, dispatch),
    })
)(CommentsSection)


// WEBPACK FOOTER //
// ./web/js/panels/task/CommentsSection.js